import React from "react";
import TextField from '@material-ui/core/TextField';
import { Grid } from "@material-ui/core";

const SafetyNotes = (props) => {
    const {title, notes, handleChange, category} = (props)
    return(
            <Grid container className="left-align safety-notes-grid" spacing={2} direction="column">
                <Grid item>
                    <label className="font-bold">{title}</label>
                </Grid>
                <Grid item>
                    <TextField
                        multiline
                        minRows={3}
                        maxRows={3}
                        fullWidth
                        value={notes}
                        onChange={evt => handleChange(evt.target.value, category)}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
    )
}
export default SafetyNotes